import VehicleFaults from 'pages/faults';
import Incidents from 'pages/incidents';
import Links from 'pages/links';
import Login from 'pages/login';
import AdminLogin from 'pages/adminLogin';
import MicrosoftRedirect from 'pages/microsoftRedirect';
import Surveys from 'pages/surveys';
import SurveysSubmission from 'pages/surveysSubmission';
import Unsubscribe from 'pages/unsubscribe';
import Users from 'pages/users';
import DashboardV2 from 'pages/dashboardv2';
import React, { Fragment, ReactElement } from 'react';
import {
	Navigate,
	Route,
	BrowserRouter as Router,
	Routes,
} from 'react-router-dom';
import ProtectedRoute from 'utils/ProtectedRoute';

const AppRoutes: React.FC = (): ReactElement => {
	return (
		<Router>
			<Fragment>
				<Routes>
					<Route path="/" element={<Navigate to={'/login'} />} />
					<Route path="/login" element={<Login />} />
					{process.env.REACT_APP_ENVIRONMENT === 'production' && (
						<Route path="/admin-login" element={<AdminLogin />} />
					)}
					<Route
						path="/connect/microsoft/redirect"
						element={<MicrosoftRedirect />}
					/>
					<Route
						path="surveys/submission/:uid"
						element={<SurveysSubmission />}
					/>
					<Route path="unsubscribe" element={<Unsubscribe />} />
					<Route element={<ProtectedRoute />}>
						<Route path="/dashboard" element={<DashboardV2 />} />
						<Route path="/vehicle-faults" element={<VehicleFaults />}>
							<Route path=":uid" element={<VehicleFaults />} />
						</Route>
						<Route path="/incidents" element={<Incidents />}>
							<Route path=":uid" element={<Incidents />} />
						</Route>
						<Route path="/links" element={<Links />} />
						<Route path="/surveys" element={<Surveys />}>
							<Route path=":uid" element={<Surveys />} />
						</Route>
						<Route path="/users" element={<Users />} />
					</Route>
				</Routes>
			</Fragment>
		</Router>
	);
};

export default AppRoutes;
